<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student_show,
                    },

                    {
                        name: $tc('messages.tags', 2),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.otherStudents"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <EmptyState v-if="subjects.length === 0" picture />
        <div v-else class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <div v-if="!!form.subject_id">
            <div v-if="contentBlocks.length" class="mt-5">
                <ContentBlockTagScores :content-blocks="contentBlocks" />
            </div>
            <EmptyState v-else picture />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import ContentBlockTagScores from '@/components/ContentBlockTagScores.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import GroupSelector from '@/components/GroupSelector.vue';

export default {
    components: {
        GroupSelector,
        ActivityMenuOptions,
        ContentBlockTagScores,
        AppButton,
        PanelPage,
        EmptyState,
        IconCircleCheckFilled,
    },
    layout: Layout,
    name: 'Index',
    props: ['subjects', 'contentBlocks', 'student', 'filters', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
